webpackJsonp([1],{

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_icons_min_css__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_icons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_icons_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_less__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_styles_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VotingForm__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_VideoClip__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Results__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_FencingDbForm__ = __webpack_require__(383);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var apiBaseUrl = '/api';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    VotingForm: __WEBPACK_IMPORTED_MODULE_7__components_VotingForm__["a" /* default */],
    VideoClip: __WEBPACK_IMPORTED_MODULE_8__components_VideoClip__["a" /* default */],
    Results: __WEBPACK_IMPORTED_MODULE_9__components_Results__["a" /* default */],
    FencingDbForm: __WEBPACK_IMPORTED_MODULE_10__components_FencingDbForm__["a" /* default */]
  },
  data: function data() {
    return {
      actions: [],
      action: {},
      currentActionIndex: 0,
      playSlow: false,
      testId: undefined,
      showTest: false,
      showResults: false,
      showInstructions: true,
      showDbForm: false,
      testResults: {},
      enableFencingDb: false
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.reset();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    startTest: function startTest() {
      this.showTest = true;
      this.showDbForm = false;
      this.showInstructions = false;
    },
    reset: function reset() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var testResponse, test;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.currentActionIndex = 0;
                _context2.next = 3;
                return fetch(apiBaseUrl + '/test/');

              case 3:
                testResponse = _context2.sent;
                _context2.next = 6;
                return testResponse.json();

              case 6:
                test = _context2.sent;

                _this2.testId = test.id;
                _this2.actions = test.actions;
                _this2.enableFencingDb = test.enableFencingDb;

                _this2.showResults = false;
                _this2.testResults = {};

                _this2.action = _this2.actions[_this2.currentActionIndex];
                _this2.action.index = _this2.currentActionIndex;

                if (!(_this2.enableFencingDb === true)) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 17;
                return _this2.$refs.fencingDbForm.reset();

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    restart: function restart() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.reset();
                _this3.showTest = true;

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    nextAction: function nextAction() {
      this.showInstructions = false;
      this.currentActionIndex += 1;

      var previousVideo = document.getElementById('video' + this.currentActionIndex);
      var video = document.getElementById('video' + (this.currentActionIndex + 1));

      // Stop and mute the previous video
      if (previousVideo !== undefined && previousVideo !== null) {
        previousVideo.pause();
        previousVideo.muted = true;
      }

      // Restart the clip at the beginning
      if (video !== undefined && video !== null) {
        video.currentTime = 0;
      }

      if (this.currentActionIndex >= this.actions.length) {
        this.getDbForm();
      } else {
        this.action = this.actions[this.currentActionIndex];
        this.action.index = this.currentActionIndex;
      }
    },
    getTestResults: function getTestResults() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var testResponse;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return fetch(apiBaseUrl + '/test/', {
                  method: 'POST',
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    testId: _this4.testId,
                    actions: _this4.actions
                  })
                });

              case 2:
                testResponse = _context4.sent;


                _this4.showTest = false;
                _this4.showResults = true;

                _context4.next = 7;
                return testResponse.json();

              case 7:
                _this4.testResults = _context4.sent;

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    getDbForm: function getDbForm() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this5.enableFencingDb === true) {
                  _this5.showTest = false;
                  _this5.showDbForm = true;
                } else {
                  _this5.dbFormSubmitted();
                }

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    dbFormSubmitted: function dbFormSubmitted() {
      this.showTest = false;
      this.showDbForm = false;
      this.getTestResults();
    },
    toggleInstructions: function toggleInstructions() {
      if (this.showTest === true && this.actions.length > 0) {
        this.showInstructions = !this.showInstructions;
      }
    }
  }
});

/***/ }),

/***/ 150:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {},
  props: {
    action: {
      type: Object,
      default: undefined
    }
  },
  data: function data() {
    var CALL_IT_FOR = 0;
    var SELECT_ACTION = 1;
    var SELECT_CARD = 2;
    var SELECT_DIFFICULTY = 3;
    var SELECT_NEITHER = 4;
    var OTHER = 5;
    var SUBMIT = 6;

    return {
      CALL_IT_FOR: CALL_IT_FOR,
      SELECT_ACTION: SELECT_ACTION,
      SELECT_CARD: SELECT_CARD,
      SELECT_DIFFICULTY: SELECT_DIFFICULTY,
      SELECT_NEITHER: SELECT_NEITHER,
      OTHER: OTHER,
      SUBMIT: SUBMIT,
      currentStepIndex: CALL_IT_FOR,
      vote: {}
    };
  },

  methods: {
    complete: function complete() {
      this.action.vote = this.vote;
      this.vote = {};
      this.$emit('complete');
      this.currentStepIndex = this.CALL_IT_FOR;
    }
  }
});

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoClip_vue__ = __webpack_require__(153);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1553aee4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoClip_vue__ = __webpack_require__(344);
function injectStyle (ssrContext) {
  __webpack_require__(343)
}
var normalizeComponent = __webpack_require__(39)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoClip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1553aee4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoClip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {},
  props: {
    action: {
      type: Object,
      default: undefined
    }
  },
  data: function data() {
    return {
      playSlow: false
    };
  },

  watch: {
    action: function action() {
      this.$refs.videoClip.load();
    }
  },
  methods: {
    changeSpeed: function changeSpeed() {
      var vid = this.$refs.videoClip;

      if (!this.playSlow) {
        vid.playbackRate = 0.65;
      } else {
        vid.playbackRate = 1;
      }
    },
    restart: function restart() {
      var vid = this.$refs.videoClip;
      vid.currentTime = 0;
    }
  }
});

/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_icons_min_css__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_icons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_icons_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VideoClip__ = __webpack_require__(152);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    VideoClip: __WEBPACK_IMPORTED_MODULE_2__VideoClip__["a" /* default */],
    BIcon: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["a" /* BIcon */],
    BIconCheckCircle: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["b" /* BIconCheckCircle */]
  },
  props: {
    results: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    verifiedActions: function verifiedActions() {
      if (this.results.actions === undefined) {
        return [];
      }

      return this.results.actions.filter(function (action) {
        return action.correctCall !== undefined;
      });
    },
    unverifiedActions: function unverifiedActions() {
      if (this.results.actions === undefined) {
        return [];
      }

      return this.results.actions.filter(function (action) {
        return action.correctCall === undefined;
      });
    },
    score: function score() {
      return this.results.easyCorrectCount + this.results.mediumCorrectCount + this.results.difficultCorrectCount;
    },
    total: function total() {
      return this.results.easy_count + this.results.medium_count + this.results.difficult_count;
    },
    newClassified: function newClassified() {
      if (this.results.actions === undefined) {
        return 0;
      }

      return this.results.actions.length - this.total;
    }
  },
  methods: {
    voteToString: function voteToString(vote) {
      var actionNames = ['Attack', 'Counter Attack', 'Riposte', 'Remise', 'Line', 'Unknown / Other', 'Simultaneous'];

      var sides = ['Left', 'Right'];

      if (vote.call_id === 6) {
        return 'Unknown / Other';
      }

      if (vote.call_id === 7) {
        return 'Simultaneous';
      }

      return actionNames[parseInt(vote.call_id, 10) - 1] + '\n       from the ' + sides[parseInt(vote.priority, 10) - 1];
    },
    difficulty: function difficulty(_difficulty) {
      var difficulties = ['Easy', 'Medium', 'Difficult'];

      return difficulties[parseInt(_difficulty, 10) - 1];
    }
  }
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {},
  props: {
    action: {
      type: Object,
      default: undefined
    }
  },
  data: function data() {
    return {
      randomClip: {},
      questions: {}
    };
  },
  methods: {
    reset: function reset() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var questionsResponse, randomClipResponse;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch('https://refereetest.quarte-riposte.com/fencingdbproxy/clips/questions/foil');

              case 2:
                questionsResponse = _context.sent;
                _context.next = 5;
                return questionsResponse.json();

              case 5:
                _this.questions = _context.sent;
                _context.next = 8;
                return fetch('https://refereetest.quarte-riposte.com/fencingdbproxy/clips/random/foil');

              case 8:
                randomClipResponse = _context.sent;
                _context.next = 11;
                return randomClipResponse.json();

              case 11:
                _this.randomClip = _context.sent;


                if (_this.$refs.videoClip !== undefined) {
                  _this.$refs.videoClip.load();
                }

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    complete: function complete() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var submit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                submit = {};

                submit['gfycat-gfy-id'] = _this2.randomClip.gfycat_gfy_id;
                _this2.questions.forEach(function (question) {
                  submit[question.id] = question.answer;
                });
                _context2.next = 5;
                return fetch('https://refereetest.quarte-riposte.com/fencingdbproxy/clips/submit', {
                  method: 'POST',
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(submit),
                  headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                    'X-Authentication-Header': 'ndn7SW/H2lf+4iTduFmNXw=='
                  }
                });

              case 5:

                _this2.$emit('submit');

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(297);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(133);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39edd03b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(386);
function injectStyle (ssrContext) {
  __webpack_require__(298)
}
var normalizeComponent = __webpack_require__(39)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39edd03b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 298:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VotingForm_vue__ = __webpack_require__(151);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_400e50de_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VotingForm_vue__ = __webpack_require__(342);
function injectStyle (ssrContext) {
  __webpack_require__(341)
}
var normalizeComponent = __webpack_require__(39)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VotingForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_400e50de_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VotingForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 341:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vote-form"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentStepIndex === _vm.CALL_IT_FOR),expression:"currentStepIndex === CALL_IT_FOR"}]},[_c('h6',{staticClass:"text-muted"},[_vm._v("Call it for")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.priority),expression:"vote.priority"}],attrs:{"id":"priority-left","name":"priority","type":"radio","value":"1"},domProps:{"checked":_vm._q(_vm.vote.priority,"1")},on:{"change":function($event){return _vm.$set(_vm.vote, "priority", "1")}}}),_vm._v(" "),_c('label',{staticClass:"text-center",attrs:{"for":"priority-left"},on:{"click":function($event){_vm.currentStepIndex = _vm.SELECT_ACTION}}},[_vm._v("\n                        Left\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col text-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.priority),expression:"vote.priority"}],attrs:{"id":"priority-right","name":"priority","type":"radio","value":"2"},domProps:{"checked":_vm._q(_vm.vote.priority,"2")},on:{"change":function($event){return _vm.$set(_vm.vote, "priority", "2")}}}),_vm._v(" "),_c('label',{staticClass:"text-center",attrs:{"for":"priority-right"},on:{"click":function($event){_vm.currentStepIndex = _vm.SELECT_ACTION}}},[_vm._v("\n                        Right\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.priority),expression:"vote.priority"}],attrs:{"id":"priority-none","name":"priority","type":"radio","value":"0"},domProps:{"checked":_vm._q(_vm.vote.priority,"0")},on:{"change":function($event){return _vm.$set(_vm.vote, "priority", "0")}}}),_vm._v(" "),_c('label',{staticClass:"text-center",attrs:{"for":"priority-none"},on:{"click":function($event){_vm.currentStepIndex = _vm.SELECT_NEITHER}}},[_vm._v("\n                        - Neither -\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_c('input',{attrs:{"type":"radio"}}),_vm._v(" "),_c('label',{staticClass:"text-center",on:{"click":function($event){_vm.currentStepIndex = _vm.SELECT_CARD}}},[_vm._v("\n                        Card\n                    ")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentStepIndex === _vm.SELECT_ACTION),expression:"currentStepIndex === SELECT_ACTION"}],staticClass:"calls"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('input',{attrs:{"type":"radio"}}),_vm._v(" "),_c('label',{on:{"click":function($event){_vm.currentStepIndex = _vm.CALL_IT_FOR}}},[_vm._v("\n                        Back\n                    ")])])]),_vm._v(" "),_c('h6',{staticClass:"text-muted"},[_vm._v("Call")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.call_id),expression:"vote.call_id"}],attrs:{"id":"call-attack","name":"call","type":"radio","value":"1"},domProps:{"checked":_vm._q(_vm.vote.call_id,"1")},on:{"change":function($event){return _vm.$set(_vm.vote, "call_id", "1")}}}),_vm._v(" "),_c('label',{attrs:{"for":"call-attack"},on:{"click":function($event){_vm.currentStepIndex = _vm.SELECT_DIFFICULTY}}},[_vm._v("\n                        Attack\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.call_id),expression:"vote.call_id"}],attrs:{"id":"call-counter-attack","name":"call","type":"radio","value":"2"},domProps:{"checked":_vm._q(_vm.vote.call_id,"2")},on:{"change":function($event){return _vm.$set(_vm.vote, "call_id", "2")}}}),_vm._v(" "),_c('label',{attrs:{"for":"call-counter-attack"},on:{"click":function($event){_vm.currentStepIndex = _vm.SELECT_DIFFICULTY}}},[_vm._v("\n                        Counter-Attack\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.call_id),expression:"vote.call_id"}],attrs:{"id":"call-riposte","name":"call","type":"radio","value":"3"},domProps:{"checked":_vm._q(_vm.vote.call_id,"3")},on:{"change":function($event){return _vm.$set(_vm.vote, "call_id", "3")}}}),_vm._v(" "),_c('label',{attrs:{"for":"call-riposte"},on:{"click":function($event){_vm.currentStepIndex = _vm.SELECT_DIFFICULTY}}},[_vm._v("\n                        Riposte\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.call_id),expression:"vote.call_id"}],attrs:{"id":"call-remise","name":"call","type":"radio","value":"4"},domProps:{"checked":_vm._q(_vm.vote.call_id,"4")},on:{"change":function($event){return _vm.$set(_vm.vote, "call_id", "4")}}}),_vm._v(" "),_c('label',{attrs:{"for":"call-remise"},on:{"click":function($event){_vm.currentStepIndex = _vm.SELECT_DIFFICULTY}}},[_vm._v("\n                        Remise\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.call_id),expression:"vote.call_id"}],attrs:{"id":"call-line","name":"call","type":"radio","value":"5"},domProps:{"checked":_vm._q(_vm.vote.call_id,"5")},on:{"change":function($event){return _vm.$set(_vm.vote, "call_id", "5")}}}),_vm._v(" "),_c('label',{attrs:{"for":"call-line"},on:{"click":function($event){_vm.currentStepIndex = _vm.SELECT_DIFFICULTY}}},[_vm._v("\n                        Line\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.call_id),expression:"vote.call_id"}],attrs:{"id":"call-other","name":"call","type":"radio","value":"6"},domProps:{"checked":_vm._q(_vm.vote.call_id,"6")},on:{"change":function($event){return _vm.$set(_vm.vote, "call_id", "6")}}}),_vm._v(" "),_c('label',{attrs:{"for":"call-other"},on:{"click":function($event){_vm.currentStepIndex = _vm.SELECT_DIFFICULTY}}},[_vm._v("\n                        Unknown / Other\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.call_id),expression:"vote.call_id"}],attrs:{"id":"call-simultaneous","name":"call","type":"radio","value":"7"},domProps:{"checked":_vm._q(_vm.vote.call_id,"7")},on:{"change":function($event){return _vm.$set(_vm.vote, "call_id", "7")}}}),_vm._v(" "),_c('label',{attrs:{"for":"call-simultaneous"},on:{"click":function($event){_vm.currentStepIndex = _vm.SELECT_DIFFICULTY}}},[_vm._v("\n                        Simultaneous\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col"})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentStepIndex === _vm.SELECT_NEITHER),expression:"currentStepIndex === SELECT_NEITHER"}],staticClass:"calls"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('input',{attrs:{"type":"radio"}}),_vm._v(" "),_c('label',{on:{"click":function($event){_vm.currentStepIndex = _vm.CALL_IT_FOR}}},[_vm._v("\n                        Back\n                    ")])])]),_vm._v(" "),_c('h6',{staticClass:"text-muted"},[_vm._v("Call")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.call_id),expression:"vote.call_id"}],attrs:{"id":"call-other2","name":"call","type":"radio","value":"6"},domProps:{"checked":_vm._q(_vm.vote.call_id,"6")},on:{"change":function($event){return _vm.$set(_vm.vote, "call_id", "6")}}}),_vm._v(" "),_c('label',{attrs:{"for":"call-other2"},on:{"click":function($event){_vm.currentStepIndex = _vm.SELECT_DIFFICULTY}}},[_vm._v("\n                        Unknown / Other\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.call_id),expression:"vote.call_id"}],attrs:{"id":"call-simultaneous2","name":"call","type":"radio","value":"7"},domProps:{"checked":_vm._q(_vm.vote.call_id,"7")},on:{"change":function($event){return _vm.$set(_vm.vote, "call_id", "7")}}}),_vm._v(" "),_c('label',{attrs:{"for":"call-simultaneous2"},on:{"click":function($event){_vm.currentStepIndex = _vm.SELECT_DIFFICULTY}}},[_vm._v("\n                        Simultaneous\n                    ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h6',{staticClass:"text-muted"},[_vm._v("Other")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.vote_comment_id),expression:"vote.vote_comment_id"}],attrs:{"name":"vote-comment"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.vote, "vote_comment_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.currentStepIndex = _vm.SUBMIT}]}},[_c('option',{attrs:{"value":"1"}},[_vm._v("No comment")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Not an action (clip doesn't have a halt, fencers only\n                            testing, etc.)\n                        ")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Fencers listed on wrong sides")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Incorrect fencers listed")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Incorect bout details")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentStepIndex === _vm.SELECT_CARD),expression:"currentStepIndex === SELECT_CARD"}],staticClass:"cards"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('input',{attrs:{"type":"radio"}}),_vm._v(" "),_c('label',{on:{"click":function($event){_vm.currentStepIndex = _vm.CALL_IT_FOR}}},[_vm._v("\n                        Back\n                    ")])])]),_vm._v(" "),_c('h6',{staticClass:"text-muted"},[_vm._v("Card For")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.card_for),expression:"vote.card_for"}],attrs:{"id":"card-left","name":"card-for","type":"radio","value":"1"},domProps:{"checked":_vm._q(_vm.vote.card_for,"1")},on:{"change":function($event){return _vm.$set(_vm.vote, "card_for", "1")}}}),_vm._v(" "),_c('label',{staticClass:"text-center",attrs:{"for":"card-left"},on:{"click":function($event){_vm.currentStepIndex = _vm.SELECT_DIFFICULTY}}},[_vm._v("\n                        Left\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col text-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.card_for),expression:"vote.card_for"}],attrs:{"id":"card-right","name":"card-for","type":"radio","value":"2"},domProps:{"checked":_vm._q(_vm.vote.card_for,"2")},on:{"change":function($event){return _vm.$set(_vm.vote, "card_for", "2")}}}),_vm._v(" "),_c('label',{staticClass:"text-center",attrs:{"for":"card-right"},on:{"click":function($event){_vm.currentStepIndex = _vm.SELECT_DIFFICULTY}}},[_vm._v("\n                        Right\n                    ")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentStepIndex === _vm.SELECT_DIFFICULTY),expression:"currentStepIndex === SELECT_DIFFICULTY"}]},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('input',{attrs:{"type":"radio"}}),_vm._v(" "),_c('label',{on:{"click":function($event){_vm.currentStepIndex = _vm.CALL_IT_FOR}}},[_vm._v("\n                        Back\n                    ")])])]),_vm._v(" "),_c('h6',{staticClass:"text-muted"},[_vm._v("Difficulty / Certainty")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.difficulty),expression:"vote.difficulty"}],attrs:{"id":"difficulty-easy","name":"difficulty","type":"radio","value":"1"},domProps:{"checked":_vm._q(_vm.vote.difficulty,"1")},on:{"change":function($event){return _vm.$set(_vm.vote, "difficulty", "1")}}}),_vm._v(" "),_c('label',{staticClass:"test",attrs:{"for":"difficulty-easy"},on:{"click":function($event){_vm.currentStepIndex = _vm.SUBMIT}}},[_vm._v("\n                        Easy\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col text-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.difficulty),expression:"vote.difficulty"}],attrs:{"id":"difficulty-medium","name":"difficulty","type":"radio","value":"2"},domProps:{"checked":_vm._q(_vm.vote.difficulty,"2")},on:{"change":function($event){return _vm.$set(_vm.vote, "difficulty", "2")}}}),_vm._v(" "),_c('label',{attrs:{"for":"difficulty-medium"},on:{"click":function($event){_vm.currentStepIndex = _vm.SUBMIT}}},[_vm._v("\n                        Medium\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col text-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vote.difficulty),expression:"vote.difficulty"}],attrs:{"id":"difficulty-hard","name":"difficulty","type":"radio","value":"3"},domProps:{"checked":_vm._q(_vm.vote.difficulty,"3")},on:{"change":function($event){return _vm.$set(_vm.vote, "difficulty", "3")}}}),_vm._v(" "),_c('label',{attrs:{"for":"difficulty-hard"},on:{"click":function($event){_vm.currentStepIndex = _vm.SUBMIT}}},[_vm._v("\n                        Hard\n                    ")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentStepIndex === _vm.SUBMIT),expression:"currentStepIndex === SUBMIT"}]},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('input',{attrs:{"type":"radio"}}),_vm._v(" "),_c('label',{on:{"click":function($event){_vm.currentStepIndex = _vm.CALL_IT_FOR}}},[_vm._v("\n                        Back\n                    ")])])]),_vm._v(" "),_c('label',{staticClass:"submit",on:{"click":function($event){return _vm.complete()}}},[_vm._v("\n                Submit\n            ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{ref:"videoClip",attrs:{"id":("video" + (_vm.action.number)),"controls":"","loop":"","muted":"true","autoplay":"true","playsinline":"","preload":"auto","tabindex":"-1"},domProps:{"muted":true}},[_c('source',{attrs:{"src":("https://actions.quarte-riposte.com" + (_vm.action.video_url)),"type":"video/mp4"}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('b',[_vm._v(_vm._s(_vm.action.left_fencer_name))])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.playSlow),expression:"playSlow"}],attrs:{"type":"checkbox","id":"changeSpeed"},domProps:{"checked":Array.isArray(_vm.playSlow)?_vm._i(_vm.playSlow,null)>-1:(_vm.playSlow)},on:{"click":function($event){return _vm.changeSpeed()},"change":function($event){var $$a=_vm.playSlow,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.playSlow=$$a.concat([$$v]))}else{$$i>-1&&(_vm.playSlow=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.playSlow=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"id":"changeSpeedLabel","for":"changeSpeed"}},[_vm._v("\n                Slow\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_c('b',[_vm._v(_vm._s(_vm.action.right_fencer_name))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Results_vue__ = __webpack_require__(154);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_332a0034_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Results_vue__ = __webpack_require__(382);
function injectStyle (ssrContext) {
  __webpack_require__(346)
}
var normalizeComponent = __webpack_require__(39)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Results_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_332a0034_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Results_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 346:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row result"},[_c('div',{staticClass:"col-lg-12"},[_c('h4',[_vm._v("You matched the verified call "+_vm._s(_vm.score)+" / "+_vm._s(_vm.total))])])]),_vm._v(" "),_vm._l((_vm.verifiedActions),function(action,index){return _c('div',[_c('div',{staticClass:"row result"},[_c('div',{staticClass:"col-lg-4"},[_c('VideoClip',{attrs:{"action":action}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[(action.correctCall !== undefined)?_c('div',[(action.correct)?_c('div',{staticClass:"h5 mb-2"},[_c('b-icon',{attrs:{"variant":"success","icon":"check-circle"}}),_vm._v("\n            Your call matched the verified call!\n          ")],1):_vm._e(),_vm._v(" "),_c('div',[_vm._v("You said: "+_vm._s(_vm.voteToString(action.submittedVote)))]),_vm._v(" "),(!action.correct)?_c('div',[_c('div',[_vm._v("The verified call was "+_vm._s(_vm.voteToString(action.correctCall)))])]):_vm._e(),_vm._v(" "),_c('div',[_vm._v("This action is classified as a "+_vm._s(_vm.difficulty(action.difficulty))+" call")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-1"},[_c('div',{staticClass:"actionId"},[_vm._v(_vm._s(action.id))])])])])}),_vm._v(" "),_c('div',{staticClass:"row result"},[_c('div',{staticClass:"col-lg-12"},[_c('h4',[_vm._v("You classified "+_vm._s(_vm.newClassified)+" new actions!")])])]),_vm._v(" "),_vm._l((_vm.unverifiedActions),function(action,index){return _c('div',[_c('div',{staticClass:"row result"},[_c('div',{staticClass:"col-lg-4"},[_c('VideoClip',{attrs:{"action":action}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('div',[_vm._v("You said: "+_vm._s(_vm.voteToString(action.submittedVote)))]),_vm._v(" "),(action.correctCall === undefined)?_c('div',[_vm._v("\n          This action has not yet been verified.\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-1"},[_c('div',{staticClass:"actionId"},[_vm._v(_vm._s(action.id))])])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FencingDbForm_vue__ = __webpack_require__(293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49205621_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FencingDbForm_vue__ = __webpack_require__(385);
function injectStyle (ssrContext) {
  __webpack_require__(384)
}
var normalizeComponent = __webpack_require__(39)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FencingDbForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49205621_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FencingDbForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 384:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[(_vm.randomClip.gfycat_gfy_id !== undefined)?_c('video',{ref:"videoClip",attrs:{"id":"video","controls":"","loop":"","autoplay":"true","playsinline":"","preload":"auto","tabindex":"-1"}},[_c('source',{attrs:{"src":("https://thumbs.gfycat.com/" + (_vm.randomClip.gfycat_gfy_id) + "-mobile.mp4"),"type":"video/mp4"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('h3',[_vm._v("Help out the Fencing Database")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.questions),function(question,index){return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h5',[_vm._v(_vm._s(question.question))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_vm._v("\n          "+_vm._s(question.note)+"\n        ")]),_vm._v(" "),_vm._l((question.options),function(option){return _c('div',{staticClass:"col-lg-6 col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(question.answer),expression:"question.answer"}],attrs:{"id":option.value,"name":question.id,"type":"radio"},domProps:{"value":option.value,"checked":_vm._q(question.answer,option.value)},on:{"change":function($event){return _vm.$set(question, "answer", option.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":option.value}},[_vm._v("\n            "+_vm._s(option.display)+"\n          ")])])})],2),_vm._v(" "),_c('hr')])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('label',{staticClass:"submit",on:{"click":_vm.complete}},[_vm._v("\n          Submit\n        ")])])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav',{staticClass:"qrnav navbar navbar-expand-lg navbar-dark"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"nav navbar-nav navbar-right"},[_c('a',{on:{"click":function($event){return _vm.toggleInstructions()}}},[_vm._v("Instructions")])])])]),_vm._v(" "),(_vm.showInstructions && _vm.actions.length > 0)?_c('div',{staticClass:"container-fluid instructions"},[_c('div',{staticClass:"col-lg-12"},[_c('h3',[_vm._v("You will be given "+_vm._s(_vm.actions.length)+" clips to referee")]),_vm._v(" "),_c('p',[_vm._v("Some notes on making calls:")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("The difficulty of the call is determined by the consensus of the votes. If everyone makes the same call, it's easy. If everyone makes a different call, then it's difficult.")]),_vm._v(" "),_c('p',[_vm._v("There are some non-action clips in there too, such as the fencers testing their weapons. If that happens, set the call to neither, and select the appropriate comment from the drop down")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTest === false),expression:"showTest === false"}],staticClass:"col-lg-12"},[_c('label',{staticClass:"submit",on:{"click":function($event){return _vm.startTest()}}},[_vm._v("\n          Start test\n        ")])])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDbForm ),expression:"showDbForm "}],staticClass:"container-fluid"},[_c('fencing-db-form',{ref:"fencingDbForm",on:{"submit":function($event){return _vm.dbFormSubmitted()}}})],1),_vm._v(" "),(_vm.showResults && _vm.testResults !== undefined)?_c('div',{staticClass:"container-fluid"},[_c('results',{attrs:{"results":_vm.testResults}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('label',{staticClass:"submit",on:{"click":function($event){return _vm.restart()}}},[_vm._v("\n            Again?\n          ")])])])],1):_vm._e(),_vm._v(" "),(_vm.showTest === true && _vm.actions !== undefined)?_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},_vm._l((_vm.actions),function(videoAction,index){return _c('div',[_c('VideoClip',{directives:[{name:"show",rawName:"v-show",value:(index === _vm.currentActionIndex),expression:"index === currentActionIndex"}],attrs:{"data-key":index,"action":videoAction}})],1)}),0),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('VotingForm',{attrs:{"action":_vm.action},on:{"complete":function($event){return _vm.nextAction()}}})],1)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-brand",attrs:{"href":"/"}},[_c('img',{attrs:{"src":__webpack_require__(387),"height":"80"}}),_vm._v("\n                Actions\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Call it for the fencer who gets the touch, whether on target or off target")]),_vm._v(" "),_c('li',[_vm._v("A stop-hit should be given as a counter attack")]),_vm._v(" "),_c('li',[_vm._v("An attack from the left that falls short followed by an attack from the right should be given as an attack")]),_vm._v(" "),_c('li',[_vm._v("An attack in preparation should be given as an attack")]),_vm._v(" "),_c('li',[_vm._v("A simultaneous action with one light should be given as simultaneous")]),_vm._v(" "),_c('li',[_vm._v("If a fencer should be carded, select card and assign it to the correct fencer")]),_vm._v(" "),_c('li',[_vm._v("If there is a halt for other reasons, give it to neither and set the call as 'Other / Unknown'")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/quarte-riposte-logos-512x512-clear.3d14aec.png";

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[294]);


// WEBPACK FOOTER //
// static/js/app.d54c32d5edb6cf454426.js